// extracted by mini-css-extract-plugin
export default {"layout":"RootLayout_layout__Z9Rvj","contentWrapper":"RootLayout_contentWrapper__Jm9bP"};